import { zodResolver } from '@hookform/resolvers/zod'
import { cn } from '@repo/tailwind-config/tailwind.functions'
import Typography from '@repo/ui/typography'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import { CenterGroupInput } from '../../../../lib/types/models/center-group/center-group-input'
import { BaseFormProps } from '../../../../lib/types/utils'
import { getSubmitAction } from '../../../../lib/utils/buttons-config/validation-buttons-config'
import { createStringSchema } from '../../../../lib/utils/validations/string-validation'
import { FORM_MODE } from '../../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../../elements/forms/form'
import ControlledInput from '../../../elements/inputs/controlled-input'
import ValidationButtons from '../../../elements/validation-buttons'

type Props = BaseFormProps<CenterGroupInput> & {
  className?: string
}

const formSchema: ZodType<CenterGroupInput> = z.object({
  name: createStringSchema('Nom'),
  color: createStringSchema('Couleur')
})

const CenterGroupForm = ({ className, defaultValues, ...validationButtonProps }: Props) => {
  const form = useForm<CenterGroupInput>({
    resolver: zodResolver(formSchema),
    defaultValues: defaultValues ?? { color: '#000000' },
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className={cn('flex flex-col gap-4', className)}>
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledInput required type="text" label="Intitulé" {...field} />
                </FormControl>
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="color"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <div className="flex items-center gap-2">
                    <Typography variant="label" className="text-[9px] text-grey">
                      Couleur
                    </Typography>
                    <input
                      {...field}
                      type={'color'}
                      className={'w-24 rounded cursor-pointer'}
                      style={{ backgroundColor: 'transparent' }}
                    />
                  </div>
                </FormControl>
              </FormItem>
            )}
          />
        </div>

        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}

export default CenterGroupForm
